import Vue from 'vue'
import Router from 'vue-router'
import Signin from './views/Signin.vue'
import ResetPass from './views/ResetPass.vue'
import InitialSignin from './views/InitialSignin.vue'
import Home from './views/Home.vue'
import UserLogout from './views/user/UserLogout.vue'
import UserMonthSalary from './views/salary/SalaryBillDetailMonth.vue'
import UserListSalary from './views/salary/SalaryDeductionInformation.vue'


Vue.use(Router)



// 例外対応
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}

const routes = [
    //{
    //    path: '/login',
    //    name: 'Login',
    //    component: Login,
    //    hidden: true
    //},
    {
        path: '/',
        name: 'Signin',
        component: Signin,
        hidden: true,
        meta: { notRequiredAuth: true }      
    },
     {
         path: '/resetPass:title',
         name: 'ResetPass',
         component: ResetPass,
         meta: { notRequiredAuth: true }
    },
    {
        path: 'initialSignin',
        name: 'InitialSignin',
        component: InitialSignin,
        meta: { notRequiredAuth: true }
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        hidden: true,
        meta: { requiredAuth: true }
    },
    {
        path: '/logout',
        name: 'Logout',
        component: UserLogout,
        hidden: true,
        meta: { notRequiredAuth: true }
     },
    {
      path: '/billDetailMonth',
      name: 'userSalary',
      component: UserMonthSalary,
      hidden: true,
      meta: { notRequiredAuth: true }
  },
  {
    path: '/userListSalary',
    name: 'userListSalary',
    component: UserListSalary,
    hidden: true,
    meta: { notRequiredAuth: true }
  },

];


const router = new Router({
    routes,
});



export default router;
